// extracted by mini-css-extract-plugin
export var cardContainer = "_ng-0";
export var cardHeader = "_ng-2";
export var collapsedState = "_ng-3";
export var dragHandle = "_ng-5";
export var dragHandleIcon = "_ng-6";
export var dragging = "_ng-1";
export var titleArea = "_ng-4";